import React from "react";
import phone from "../assets/images/phone/6.png";
import { FiDownload, FiLogIn, FiGift } from "react-icons/fi";
import { IconType } from "react-icons";

interface Step {
  icon: IconType;
  title: string;
  desc: string;
}

const steps: Step[] = [
  {
    icon: FiDownload,
    title: "Descarga la app",
    desc: "Instala Club333 en tu celular y accede a tu cuenta de forma rápida y segura.",
  },
  {
    icon: FiLogIn,
    title: "Inicia sesión",
    desc: "Ingresa con tus datos para consultar tu tarjeta digital, puntos y saldos disponibles.",
  },
  {
    icon: FiGift,
    title: "Disfruta tus beneficios",
    desc: "Recarga saldo, recibe promociones y ordena alimentos y bebidas desde la app.",
  },
];

export default function AboutOne() {
  return (
    <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
      <div className="lg:col-span-5 md:col-span-6">
        <div className="overflow-hidden absolute md:size-[500px] size-[400px] bg-gradient-to-tr to-red-500/20 via-red-500/70 from-red-500 bottom-1/2 translate-y-1/2 md:start-[40px] start-1/2 md:translate-x-0 -translate-x-1/2 -z-1 shadow-md shadow-red-500/10 rounded-full"></div>
        <img src={phone} className="mx-auto md:max-w-xs lg:max-w-sm" alt="" />
      </div>

      <div className="lg:col-span-7 md:col-span-6">
        <div className="lg:ms-10">
          <h6 className="text-white lg:text-red-500 uppercase text-sm font-bold tracking-wider mb-3">
            Pasos
          </h6>

          <h4 className="mb-10 md:text-4xl text-3xl md:leading-normal leading-normal font-bold text-slate-900 dark:text-white">
            Comienza a usar Club333 <br /> en pocos pasos
          </h4>

          <div className="relative space-y-12">
            <div className="absolute start-[38px] top-10 bottom-10 w-px bg-gray-200 dark:bg-white/10"></div>

            {steps.map((item, index) => {
              const Icon = item.icon;

              return (
                <div key={index} className="relative flex gap-6 items-start">
                  <span className="absolute -start-16 top-0 text-8xl font-bold leading-none text-slate-900/10 text-red-500">
                    {index + 1}
                  </span>

                  <div className="relative z-2 shrink-0 size-20 rounded-xl bg-white dark:bg-[#1d1d1d] shadow-lg dark:shadow-black/30 border border-gray-100 dark:border-white/10 flex items-center justify-center">
                    <Icon className="size-9 text-red-500" />
                  </div>

                  <div className="pt-1 relative z-2">
                    <h5 className="text-xl font-bold text-slate-900 dark:text-white mb-3">
                      {item.title}
                    </h5>

                    <p className="text-slate-500 dark:text-[#b5b5b5] max-w-xl leading-7">
                      {item.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}